import React, { useState } from "react";
import BootScreen from "./BootScreen";

const ShutdownOverlay = ({ onClose }) => {
  const [phase, setPhase] = useState("confirm");

  if (phase === "booting") {
    return (
      <BootScreen
        honorReducedMotion={false}
        onDone={() => {
          setPhase("confirm");
          onClose();
        }}
      />
    );
  }

  if (phase === "off") {
    return (
      <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-4 bg-black px-6 text-center font-mono98 text-[#c0c0c0]">
        <p className="text-lg sm:text-xl">It's now safe to close this tab.</p>
        <button
          type="button"
          onClick={() => setPhase("booting")}
          className="win-btn win-focus-dotted px-4 py-2 text-sm font-bold text-black"
        >
          Restart JAKOB-OS
        </button>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="win-raised w-[300px] p-[3px]">
        <div className="win-titlebar-active flex items-center px-2 py-1 text-sm font-bold text-white">
          Shut Down Windows
        </div>
        <div className="flex items-start gap-3 bg-[#c0c0c0] p-4">
          <span className="text-3xl" aria-hidden="true">💻</span>
          <p className="text-xs leading-5">Are you sure you want to shut down JAKOB-OS?</p>
        </div>
        <div className="flex justify-end gap-2 bg-[#c0c0c0] px-4 pb-4">
          <button type="button" className="win-btn win-focus-dotted px-4 py-1.5 text-xs font-bold" onClick={() => setPhase("off")}>
            Yes
          </button>
          <button type="button" className="win-btn win-focus-dotted px-4 py-1.5 text-xs font-bold" onClick={onClose}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShutdownOverlay;
